<template>
  <div :class="checkedItems.length > 0 ? 'sticky' : ''">
    <div class="container toolbar" v-if="showAdd && checkedItems.length == 0">
      <b-tooltip
        label="新規オーダーは購入していない車両を陸送する場合のみ使用してください。"
        type="is-dark"
        position="is-right"
        size="is-large"
        multilined
      >
        <b-button
          @click="createOrder"
          class="is-size-7"
          icon-left="plus"
          label="新規オーダー"
        />
      </b-tooltip>
      <div class="filter-input">
        <div class="control">
          <b-field label="顧客名">
            <b-input size="is-small" v-model="customerName" />
          </b-field>
        </div>
        <div class="control">
          <b-field label="顧客ID">
            <b-input size="is-small" v-model="customerId" />
          </b-field>
        </div>
      </div>
    </div>
    <div class="container actionbar" v-if="checkedItems.length > 0">
      <div>{{ checkedItems.length }} selected</div>
      <div class="actionbar-items">
        <b-button
          v-if="isBooked"
          class="is-size-7"
          label="2回目以上陸送依頼"
          @click="createListTransport"
        />
        <b-button
          v-if="isOrders"
          class="is-size-7"
          label="Request Booking"
          @click="requestUpdateOrder"
        />
        <b-button
          v-if="!isOrders && !isBooked && tab == 'company'"
          class="is-size-7"
          label="✓車両の陸送発注票"
          @click="requestBookingformCheckedItem"
        />
        <b-button
          v-if="!isBooked"
          class="is-size-7"
          icon-left="calendar-day"
          label="搬入期限の依頼補記"
          @click="setTransportEstimatedArrivalDate"
        />
        <b-button
          v-if="isBooked"
          class="is-size-7"
          icon-left="calendar-day"
          label="請求書確認日"
          @click="setRequestDate"
        />
        <b-button
          v-if="!isOrders && !isBooked"
          class="is-size-7"
          icon-left="calendar-day"
          label="手配完了"
          @click="setRequestConfirmDate"
        />
        <b-button
          v-if="!isOrders"
          class="is-size-7"
          icon-left="calendar-day"
          label="納車予定"
          @click="setETA"
        />
        <b-button
          v-if="isBooked"
          class="is-size-7"
          icon-left="calendar-day"
          label="請求書作成日"
          @click="setInvoiceIsuueDate"
        />
        <b-button
          class="is-size-7"
          icon-left="trash-alt"
          @click="deleteOrders"
          :disabled="checkedItems.length == 0"
          v-if="showAdd"
        />
      </div>
    </div>
  </div>
</template>
<style scoped>
.sticky {
  position: sticky;
  top: 1rem;
  z-index: 1;
}
.toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}
.actionbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding: 5px 10px;
  border-radius: 3px;
  border: 1px solid #5f75d5;
  background-color: #e6efff;
}
.actionbar .actionbar-items {
  display: flex;
  justify-content: space-between;
  gap: 3px;
  align-items: center;
}
.filter-input {
  display: inherit;
  margin-left: 20px;
}
.filter-input .control {
  margin-left: 5px;
}
</style>
<script>
import itemRepository from '@/repositories/item';
import jcPackage from '@/repositories/jcPackage';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import InlineDateEditor from './InlineDateEditor';
import TransportPopup from './TransportPopup';
const inlineDateEditorModal = {
  component: InlineDateEditor,
  hasModalCard: true,
  trapFocus: true,
};
const transportPopup = {
  component: TransportPopup,
  hasModalCard: true,
  trapFocus: true,
};
export default {
  props: [
    'add',
    'del',
    'checkedItems',
    'isBooked',
    'listTransportTotalRequest',
    'isOrders',
    'isAllBooked',
    'tab',
  ],
  data: () => ({
    customerId: '',
    customerName: '',
    transportFromId: '',
    transportFromName: '',
    isValidCreateTransport: false,
    isValidRequestTransport: false,
    recordError: 0,
    errorVinNo: [],
    errorMsg: '',
    isValidToCreateTransportWhenMatterNoEmpty: false,
    errorVinNoWhenMatterNoEmpty: [],
  }),
  computed: {
    showAdd() {
      return this.add != undefined;
    },
    showDel() {
      return this.del != undefined;
    },
  },
  async created() {
    this.$watch(
      () => [this.customerName, this.customerId],
      () => this.emit()
    );
  },
  methods: {
    setTransportEstimatedArrivalDate() {
      this.$buefy.modal.open({
        ...inlineDateEditorModal,
        props: {
          title: '搬入期限の依頼補記',
          handler: this.setDeliveryDateDeadline(
            'transportEstimatedArrivalDate'
          ),
        },
      });
    },
    setDeliveryDateDeadline(key) {
      return async (a) => {
        await Promise.all(
          this.checkedItems.map((item) => {
            item[key] = a && moment(a).format('YYYY-MM-DD');
            const constDeliveryString = '※MM/ddまでの搬入をお願いします。';
            const regex = /(※.*?。)/;
            const splitItems = item['transportRemarks'].split(regex);
            let arr = [];
            for (let i = 0; i < splitItems.length; i++) {
              if (regex.test(splitItems[i])) {
                arr.push(splitItems[i]);
              }
            }
            if (arr.length > 0) {
              for (let i = 0; i < arr.length; i++) {
                item['transportRemarks'] = item['transportRemarks'].replace(
                  arr[i],
                  constDeliveryString.replace(
                    'MM/dd',
                    moment(item[key]).format('MM/DD')
                  )
                );
              }
            }
            return itemRepository.save(item);
          })
        );
        this.$emit('done');
      };
    },
    createListTransport() {
      //validate data
      this.isValidCreateTransport = false;
      this.recordError = 0;
      this.checkedItems.map((item) => {
        this.checkValidation(item);
      });
      if (this.isValidCreateTransport) {
        let msg ='「'+this.errorVinNo.join('、')+'」'+
          'のレコードが2回目以上陸送条件を満たしません。（納品予定日が未入力）';
        this.alertError(msg);
        this.$emit('done');
        return;
      }
      if(this.isValidToCreateTransportWhenMatterNoEmpty){
         let msg =
          '「'+this.errorVinNoWhenMatterNoEmpty.join('、')+'」'+
          'のレコードはJCPACKとの連携がされていない為、2回目陸送を作成できません。<br>15分程度時間を空けてください。';
        this.alertError(msg);
        this.$emit('done');
        return;
      }
      this.$store.commit('isLoadingApi', true);
      const checkedLength = this.checkedItems.length
      Promise.all(
        this.checkedItems.map(async(item) => {
            this.createNewItemOrder(item);
            item.id = uuidv4();
            await this.$store.dispatch('createNewTransport', item);
        })
      ).then(async () => {
        // re-get data 
        await this.$store.dispatch('fetchOrdersAndBookingItems');
        this.$store.commit('setOrdersCount', this.$store.getters.incompleteItems.length);
        const message =
          '<b>' +
            checkedLength +
          '/' +
            checkedLength +
          '</b>のレコードが2回目以上陸送依頼完了致しました。';
        this.alertSuccess(message);
        this.$store.commit('isLoadingApi', false);
      })
      this.$emit('done');
      // jcPackage
      //   .createListTransport(
      //     this.$store.state.accessTokenJPC,
      //     this.checkedItems
      //   )
      //   .then(async (rs) => {
      //     const dataResponse = rs.data;
      //     const checkedLength = this.checkedItems.length
      //     if (dataResponse) {

      //       Promise.all(
      //         this.checkedItems.map(async(item) => {
      //           if (dataResponse.indexOf(item.id) > -1) {
      //             this.createNewItemOrder(item);
      //             item.id = uuidv4();
      //             await this.$store.dispatch('createNewTransport', item);
      //           }
      //         })
      //       ).then(async () => {
      //         // re-get data 
      //         await this.$store.dispatch('fetchOrdersAndBookingItems');
      //         this.$store.commit('setOrdersCount', this.$store.getters.incompleteItems.length);
      //         const message =
      //           '<b>' +
      //             dataResponse.length +
      //           '/' +
      //           checkedLength +
      //           '</b>のレコードが2回目以上陸送依頼完了致しました。';
      //         this.alertSuccess(message);
      //         this.$store.commit('isLoadingApi', false);
      //       })
      //     }
      //   })
      //   .finally(async() => {
      //     this.$emit('done');
      //   });
    },
    createNewItemOrder(item) {
      item.orderDate = moment().format('YYYY-MM-DD');
      item.transportFromId = item.transportToId;
      item.transportFromName = item.transportToName;
      item.yardTransportId = item.transportToId;
      item.yardTransportName = item.transportToName;
      item.yardAdressTransport = item.transportToAddress;
      item.yardAreaTransport = item.transportToArea;
      item.transportRequestChange = 'true';
      item.conditionChecked = false;
      item.lotNo = '';
      item.pos = '';
      item.postAccount = '';
      item.transportVendorId = '';
      item.transportVendorName = '';
      item.transportToAddress = '';
      item.transportToArea = '';
      item.transportToId = '';
      item.transportToIncharge = '';
      item.transportToName = '';
      item.transportToPhone = '';
      item.transportToRemarks = '';
      item.transportRemarks = '';
      item.transportNote = '';
      item.transportActualCost = 0;
      item.transportOutFee = 0;
      item.transportNumberPlateCutFee = 0;
      item.transportTotalActualCost = 0;
      item.transportCost = 0;
      item.regularCharge = '';
      item.transportTotalCost = 0;
      item.transportRequestDate = '';
      item.transportRequestConfirmDate = '';
      item.transportEstimatedArrivalDate = '';
      item.yardConfirmationDate = '';
      item.yardConfirmed = '';
      item.landTransportationArrangementDate = '';
      item.landTransportationArranger = '';
      item.transportRequestChange = '';
      item.newRequestTransportFlg = 'false';
      item.isUpdate = 0;
      item.fromYardPlace = item.yardIdTemp;
      item.hasNumberPlate = false;
      item.handlingCompanyEn = '';
      item.handlingCompanyJp = '';
      item.invoiceIsuueDate = '';
      item.yardCity1 = '';
      item.dateConfirmFeeTransport = '';
      item.userConfirmFeeTransport = '';
      item.transportDetailId = 0;
      item.conditionIsSelftpropelled = false;
      item.conditionIsLoadedTransport = false;
      item.isOpenSearchAddressByZipCodePopupFlag = false;
      item.suppliersName = '';
      item.addressByZipcode = '';
      item.areaByZipcode = '';
      item.tranRequest = item.tranRequest + 1;
      item.isInvoiceFinish = '0';
    },
    alertSuccess(data) {
      this.$buefy.dialog.alert({
        title: 'Request Success',
        type: 'is-success',
        hasIcon: true,
        icon: 'check-circle',
        iconPack: 'fa',
        message: data,
        confirmText: 'OK!',
        ariaRole: 'alertdialog',
        ariaModal: true,
      });
    },
    alertError(msg) {
      this.$buefy.dialog.alert({
        title: 'Request Error',
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa',
        ariaRole: 'alertdialog',
        ariaModal: true,
        dangerouslyUseHTMLString: true,
        onClose: () => {
          this.errorVinNo = [];
          this.errorVinNoWhenMatterNoEmpty = [];
        },
        onConfirm: () => {
          this.errorVinNo = [];
          this.errorVinNoWhenMatterNoEmpty = [];
        }
      });
    },
    checkValidation(item) {
      if (item.transportEstimatedArrivalDate == '') {
        this.isValidCreateTransport = true;
        this.recordError++;
        this.errorVinNo.push(item.vinNo);
        return;
      }
      if(item.matterNo === ''){
        this.isValidToCreateTransportWhenMatterNoEmpty = true;
        this.errorVinNoWhenMatterNoEmpty.push(item.vinNo);
      }
    },
    emit() {
      const dataSearch = {
        customerName: this.customerName,
        customerId: this.customerId,
      };
      this.$emit('getDataSearch', dataSearch);
    },
    setRequestDate() {
      this.$buefy.modal.open({
        ...inlineDateEditorModal,
        props: {
          title: '請求書確認日',
          handler: this.setDate('transportRequestDate'),
        },
      });
    },
    setRequestConfirmDate() {
      this.$buefy.modal.open({
        ...inlineDateEditorModal,
        props: {
          title: '手配完了日',
          handler: this.setDate('transportRequestConfirmDate'),
        },
      });
    },
    setETA() {
      this.$buefy.modal.open({
        ...inlineDateEditorModal,
        props: {
          title: '納車予定日',
          handler: this.setDate('transportEstimatedArrivalDate'),
        },
      });
    },
    setInvoiceIsuueDate() {
      this.$buefy.modal.open({
        ...inlineDateEditorModal,
        props: {
          title: '請求書作成日',
          handler: this.setDate('invoiceIsuueDate'),
        },
      });
    },
    setDate(key) {
      return async (a) => {
        await Promise.all(
          this.checkedItems.map(async(item) => {
            item[key] = a && moment(a).format('YYYY-MM-DD');
            if ( item.status == 2 && (item.transportDetailId  == 0 || item.transportDetailId == null) && item.transportRequestConfirmDate != '') {
              let itemTemp = await itemRepository.getItemById(item.id);
              if (itemTemp) {
                item.transportDetailId = itemTemp.transportDetailId;
              }
            }
            return itemRepository.save(item);
          })
        );
        this.$emit('done');
      };
    },
    async createOrder() {
      const o = await itemRepository.create();
      this.$emit('done', { id: o.id });
    },
    deleteOrders() {
      this.$buefy.dialog.confirm({
        message: `選択した ${this.checkedItems.length} 件を削除しますか？`,
        onConfirm: async () => {
          await Promise.all(
            this.checkedItems.map((item) => itemRepository.delete(item.id))
          );
          this.$buefy.toast.open('削除しました');
          this.$emit('done');
        },
      });
    },
    requestUpdateOrder() {
      this.isValidRequestTransport = false;
      this.errorVinNo = [];
      this.checkedItems.map((item) => {
        this.transportFromId = item.transportFromId;
        this.transportFromName = item.transportFromName;
        return;
      });
      this.validateInputRequest();
      if (this.isValidRequestTransport) {
        this.alertError(
          '2回目以降の陸送ではないレコードがあります。「' +
            this.errorVinNo +
            '」。'
        );
        return;
      }
      this.checkedItems.map((item) => {
        if ((item.transportFromId != this.transportFromId)||(item.customerId != this.checkedItems[0].customerId) ) {
          this.isValidRequestTransport = true;
          return;
        }
      });
      if (this.isValidRequestTransport) {
        this.alertError('「オークション会場」の値が統一すること。');
        return;
      }
      this.$buefy.modal.open({
        ...transportPopup,
        props: {
          title: 'Input Transport',
          handler: this.updateItem(),
          auctions: this.$store.state.auctionVendors,
          yards: this.$store.state.yardVendors,
          transportVendors: this.$store.state.transportVendors,
          transportFromId: this.transportFromId,
          transportFromName: this.transportFromName,
          fromYardPlace : this.checkedItems[0].fromYardPlace,
          customerId : this.checkedItems[0].customerId,
          customerGrade : this.checkedItems[0].customerGrade
        },
      });
    },
    updateItem() {
      return async (el) => {
        console.log(el);
        await Promise.all(
          this.checkedItems.map((item) => {
            item.conditionChecked = true;
            item.transportActualCost = el.transportActualCost
              ? el.transportActualCost
              : 0;
            item.transportCost = el.transportCost ? el.transportCost : 0;
            item.transportCostId = el.transportCostId ? el.transportCostId : '';
            item.transportFromId = el.transportFromId;
            item.transportFromName = el.transportFromName;
            item.transportNumberPlateCutFee = el.transportNumberPlateCutFee
              ? el.transportNumberPlateCutFee
              : 0;
            item.transportOutFee = el.transportOutFee ? el.transportOutFee : 0;
            item.transportPlan = el.transportPlan ? el.transportPlan : 0;
            item.transportPlanFee = el.transportPlanFee
              ? el.transportPlanFee
              : 0;
            item.transportRemarks = el.transportRemarks
              ? el.transportRemarks
              : '';
            item.transportToAddress = el.transportToAddress;
            item.transportToArea = el.transportToArea;
            item.transportToId = el.transportToId;
            item.transportToIncharge = el.transportToIncharge;
            item.transportToName = el.transportToName;
            item.transportToPhone = el.transportToPhone;
            item.transportToRemarks = el.transportToRemarks;
            item.transportTotalActualCost = el.transportTotalActualCost
              ? el.transportTotalActualCost
              : 0;
            item.transportTotalCost = el.transportTotalCost
              ? el.transportTotalCost
              : 0;
            item.transportVendorId = el.transportVendorId;
            item.transportVendorName = el.transportVendorName;
            item.transportEstimatedArrivalDate = el.transportEstimatedArrivalDate
              ? moment(el.transportEstimatedArrivalDate).format('YYYY-MM-DD')
              : '';
            item.handlingCompanyEn = el.handlingCompanyEn;
            item.handlingCompanyJp = el.handlingCompanyJp;
            item.yardCategory = el.yardCategory;
            return itemRepository.save(item);
          })
        );
        this.$emit('done');
      };
    },
    validateInputRequest() {
      this.checkedItems.map((item) => {
        if (item.matterNo == '') {
          this.errorVinNo.push(item.vinNo);
          this.isValidRequestTransport = true;
          return;
        }
        this.listTransportTotalRequest.find((v) => {
          if (JSON.parse(v).matterNo == item.matterNo) {
            if (JSON.parse(v).totalRequest < 1) {
              this.errorVinNo.push(item.vinNo);
              this.isValidRequestTransport = true;
              return;
            }
          }
        });
      });
    },
    requestBookingformCheckedItem() {
      const vendorIdTemp = this.checkedItems[0]? this.checkedItems[0].transportVendorId : '';
      const checkMutilVendor = this.checkedItems.some((res) => res.transportVendorId !== vendorIdTemp);
      if (!vendorIdTemp) return;
      if (checkMutilVendor) {
        this.alertError(
          '単一の陸送会社のみにチェックを入れてください'
        );
        return;
      } else {
        const id = vendorIdTemp;
        const tabActive = 0;
        const idTempList = this.checkedItems.map(item => item.id);
        this.$store.commit('setListIdBooking', idTempList);
        this.$router.push({
          name: 'booking-form',
          params: {
            id: id,
            type: tabActive,
          }
        });
      }
    }
  },
};
</script>
